import { ProofOfDeliveryDocuments } from '../../models/delivery-note-proof-of-delivery.model';
import { DeliveryNoteParams } from '../../models';

export class DeliveryNoteProofOfDeliveryLoad {
  public static readonly type = '[DeliveryNoteProofOfDelivery] Load';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteProofOfDeliverySave {
  public static readonly type = '[DeliveryNoteProofOfDelivery] Save';
  constructor(
    public payload: { deliveryNoteNumber: string; sapId: string; proofOfDeliveryItemValue: ProofOfDeliveryDocuments },
  ) {}
}

export class DeliveryNoteProofOfDeliveryDownloadFile {
  public static readonly type = '[DeliveryNoteProofOfDelivery] Download File';
  constructor(public payload: { deliveryNoteNumber: string; sapId: string; documentId: string; name: string }) {}
}

export class DeliveryNoteProofOfDeliverySendRequest {
  public static readonly type = '[DeliveryNoteProofOfDelivery] Send request';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteProofOfDeliveryInitialState {
  public static readonly type = '[DeliveryNoteProofOfDelivery] Set initial state';
}
